import { computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

export function useSlideshow(itemLength: number) {
  const currentIndex = ref(0)
  const triggerNext = ref(false)
  const triggerPrev = ref(false)
  const triggerVideoEnded = ref(false)
  const location = ref<HTMLDivElement>()

  const showNext = computed(() => currentIndex.value < itemLength - 1)
  const showPrev = computed(() => currentIndex.value > 0)

  function handleVideoEnded() {
    triggerVideoEnded.value = !triggerVideoEnded.value
  }

  onMounted(() => {
    location.value = <HTMLDivElement>getCurrentInstance()?.refs.location
    // location.value?.querySelector<HTMLVideoElement>('video.preview')?.addEventListener('ended', handleVideoEnded)

    // -- kaew dev fix more videos --------------
    if (location.value) {
      const previewVideos: NodeListOf<HTMLVideoElement> = location.value.querySelectorAll('video.preview')
      previewVideos.forEach((video) => {
        console.log(video.src)
        // Add event listeners to each preview video
        video.addEventListener('ended', handleVideoEnded)
      })
    }
    // ------------------------------------------
  })

  // onBeforeUnmount(() => {
  //   location.value?.querySelector<HTMLVideoElement>('video.preview')?.removeEventListener('ended', handleVideoEnded)
  // })

  function next() {
    const nextId = currentIndex.value >= itemLength - 1 ? 0 : currentIndex.value + 1
    currentIndex.value = nextId
    triggerNext.value = !triggerNext.value
  }

  function prev() {
    currentIndex.value -= currentIndex.value > 0 ? 1 : 0
    triggerPrev.value = !triggerPrev.value
  }

  function onCurrentIndexChanged(handle: (index: number) => void) {
    watch(currentIndex, (index) => {
      handle(index)
    })
  }

  function onPrev(handle: (index: number) => void) {
    watch(triggerPrev, () => {
      handle(currentIndex.value)
    })
  }

  function onNext(handle: (index: number) => void) {
    watch(triggerNext, () => {
      handle(currentIndex.value)
    })
  }

  function onVideoEnded(handle: (index: number) => void) {
    watch(triggerVideoEnded, () => {
      handle(currentIndex.value)
    })
  }

  return {
    currentIndex,
    showNext,
    showPrev,
    next,
    prev,
    onCurrentIndexChanged,
    onPrev,
    onNext,
    onVideoEnded,
  }
}
